'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var pxToVwMixins = exports.pxToVwMixins = {
    methods: {
        transSourceToPx: function transSourceToPx(sourcedata) {
            if (typeof window === 'undefined') return sourcedata + 'px';
            var iseditor = process.env.MODE === 'editor' || document.body.clientWidth > 768;
            return iseditor ? sourcedata + 'px' : parseFloat(100 * Number(sourcedata) / 375).toFixed(1) + 'vw';
        }
    }
};